import { AppLayout } from "@main/app/layouts/app-layout";
import { SessionFlowLayout } from "@main/app/layouts/session-flow-layout";
import UnsupportedPage from "@main/app/pages/unsupported-page";
import {
  EvalRunnerPage,
  NearMissCapturePage,
  NearMissLabelerPage,
  TrialRecorderPage,
} from "@main/features/eval";
import { HomePage, SessionDetailPage, SessionsPage } from "@main/features/history";
import { PermissionDeniedPage, SessionPage } from "@main/features/session";
import { Route, Router } from "@solidjs/router";
import { lazy } from "solid-js";

const NotFoundPage = lazy(() => import("@main/app/pages/not-found-page"));

// `/dev/eval-runner` ・`/dev/trial-recorder` route 登録に使う。 module top-level に書くことで
// `VITE_DEV_EVAL` 未定義の production build では `false` リテラルに畳まれ、
// `{DEV_EVAL && <Route .../>}` 配下の features/eval 経路が treeshake で完全に
// dead-code-eliminate される。
const DEV_EVAL = import.meta.env.VITE_DEV_EVAL === "true";

export function App() {
  return (
    <Router root={AppLayout}>
      <Route path="/" component={HomePage} />
      <Route path="/sessions" component={SessionsPage} />
      <Route path="/sessions/:id" component={SessionDetailPage} />
      {/* §4.4: コア機能 (Document PiP API / getUserMedia / WebGL2) を欠く環境向けの非対応案内。
          起動時の全画面ブロックは廃し、 セッション開始試行時に startSessionFlow がここへ navigate
          する (履歴閲覧は非対応環境でも可能 = 権限拒否ブランチと対称)。 */}
      <Route path="/unsupported" component={UnsupportedPage} />
      {/* §5.2 / URL 設計: /session と /permission-denied は同一 session flow scope として
          SessionFlowLayout 配下に nest する。 page 跨ぎ遷移で Provider が unmount せず、
          worker の resource を維持できる。 PoC B では <Switch> による state machine 駆動の
          UI 切替は session-page 内に残るが、 Provider scope は Layout (URL scope) に揃える。 */}
      <Route component={SessionFlowLayout}>
        <Route path="/permission-denied" component={PermissionDeniedPage} />
        <Route path="/session" component={SessionPage} />
      </Route>
      {/* dev-only Route: VITE_DEV_EVAL=true でのみ登録される。 production build では DEV_EVAL が
          `false` リテラルに畳まれ、 `false && <Route .../>` が dead-code-eliminate されるため
          `features/eval/` への lazy import 連鎖は dist に残らない (R31 / AE10)。 features/eval/index.ts
          側でも DEV_EVAL ガードを置いており、 production では EvalRunnerPage / TrialRecorderPage が
          `undefined` になる (= `lazy(() => import(...))` 自体が dead で lazy chunk も emit されない)。
          `EvalRunnerPage && <Route .../>` で型 guard を入れることで `exactOptionalPropertyTypes: true`
          配下でも `component: Component | undefined` を `Component` に narrow する。 */}
      {DEV_EVAL && EvalRunnerPage && <Route path="/dev/eval-runner" component={EvalRunnerPage} />}
      {DEV_EVAL && TrialRecorderPage && <Route path="/dev/trial-recorder" component={TrialRecorderPage} />}
      {DEV_EVAL && NearMissCapturePage && (
        <Route path="/dev/near-miss-capture" component={NearMissCapturePage} />
      )}
      {DEV_EVAL && NearMissLabelerPage && (
        <Route path="/dev/near-miss-labeler" component={NearMissLabelerPage} />
      )}
      <Route path="*" component={NotFoundPage} />
    </Router>
  );
}
